import { combineReducers } from 'redux';
import passengersReducer from './passengers/reducers';
import loadingReducer from './loading/reducers';
import refundInfoReducer from './refundInfo/reducers';
import selectedReasonsReducer from './selectedReason/reducers';
import documentsReducer from './documents/reducers';
import gdsServicesRefundInfoReducer from './gdsServicesRefundInfo/reducers';
import modalReducer from './modal/reducers';
const rootReducer = combineReducers({
    refundInfo: refundInfoReducer,
    gdsServicesRefundInfo: gdsServicesRefundInfoReducer,
    passengers: passengersReducer,
    selectedReason: selectedReasonsReducer,
    documents: documentsReducer,
    loading: loadingReducer,
    modal: modalReducer
});
export default rootReducer;
